import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface TaskStateType {
  taskIds: string[];
  bulkType: string;
}

const initialState :TaskStateType = {
  taskIds: [],
  bulkType: 'single',
};

export const bulkUpdateTasksSlice = createSlice({
  name: 'bulkUpdateTasks',
  initialState,
  reducers: {
    resetBulkUpdateTasks: () => initialState,
    setBulkUpdateIds: (state, action: PayloadAction<{
      taskIds: string[];
      type: string;
    }>) => {
      const {
        taskIds,
        type,
      } = action.payload;
      state.taskIds = taskIds;
      state.bulkType = type;
    },
  },
});

export const {
  resetBulkUpdateTasks,
  setBulkUpdateIds,
} = bulkUpdateTasksSlice.actions;

export default bulkUpdateTasksSlice.reducer;
